var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticClass:"color-picker",attrs:{"type":"color"},domProps:{"value":_vm.color},on:{"change":function($event){return _vm.$emit('change', $event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }